import BlockLeftImage from "./BlockLeftImage";
import Accordion from "./Accordion";

 
import {
  BadgePercent,
  GraduationCap,
  CreditCard,
  CircleCheck,
  ChevronRight,
} from "lucide-react";
import DescuentosEscuelaNegocios from "../newPages/homenew/DescuentosEscuelaNegocios";
import DescuentosPosgrados from "../newPages/homenew/DescuentosPosgrados";

export function PosgradosPagosCiencias() {
  return (
    <>
      <section
        id="descuentos"
        className="relative overflow-hidden rounded-3xl border border-slate-200 p-6 md:p-10 shadow-xl"
      >
        {/* Glow adaptado al Azul Institucional con opacidad baja */}
        <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-[#004270]/5 blur-3xl" />
        <div className="absolute -bottom-24 -left-24 h-72 w-72 rounded-full bg-[#004270]/5 blur-3xl" />

        <div className="relative z-10">
          {/* Header */}
          <div className="mb-8 flex items-start gap-4">
            {/* Icono con fondo azul institucional muy claro y texto azul institucional */}
            <div className="flex h-16 w-16 items-center justify-center rounded-2xl bg-[#004270]/10 text-[#004270] shadow-sm">
              <BadgePercent className="h-8 w-8" />
            </div>

            <div>
              {/* Badge con fondo gris claro y texto azul institucional */}
              <span className="mb-2 inline-flex rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold uppercase tracking-wide text-[#004270]">
                Beneficios económicos
              </span>

              <h2 className="text-3xl font-montserrat font-bold leading-tight text-slate-900">
                Obtén hasta un {/* Destacado con el azul institucional */}
                <span className="text-[#004270] font-montserrat">
                  30% de descuento
                </span>{" "}
                en tu matrícula
              </h2>

              <p className="text-m p-0 m-0 text-slate-600 mt-2">
                Aprovecha descuentos exclusivos, becas y facilidades de pago
                para iniciar tu formación profesional. Los beneficios otorgados
                entre becas y descuentos no podrán exceder el 30% del valor
                total.
              </p>
            </div>
          </div>

          {/* Grid */}
          <div className="grid gap-6 lg:grid-cols-2">
            {/* Descuentos */}
            <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg">
              <div className="mb-5 flex items-center gap-3">
                {/* Icono con fondo gris/azul claro y texto azul institucional */}
                <div className="rounded-xl bg-slate-100 p-3 text-[#004270]">
                  <BadgePercent className="h-6 w-6" />
                </div>

                <h3 className="text-2xl font-bold text-slate-900">
                  Descuentos
                </h3>
              </div>

              <div className="space-y-5">
                <div className="flex gap-3">
                  <div>
                    {/* Checkmarks ahora en color institucional #004270 */}
                    <CircleCheck className="mt-1 h-5 w-5 text-[#004270]" />
                  </div>
                  <p className="text-slate-700 leading-7 p-0">
                    10% de descuento especial por programa de maestría.
                  </p>
                </div>

                <div className="flex gap-3">
                  <div>
                    <CircleCheck className="mt-1 h-5 w-5 text-[#004270]" />
                  </div>
                  <p className="text-slate-700 leading-7 p-0">
                    10% de descuento al pagar el programa completo o 5% de
                    descuento si eliges pago semestral.
                  </p>
                </div>

                <div className="flex gap-3">
                  <div>
                    <CircleCheck className="mt-1 h-5 w-5 text-[#004270]" />
                  </div>
                  <p className="text-slate-700 leading-7 p-0">
                    10% adicional si eres UTPL Alumni.
                  </p>
                </div>

                <div className="flex gap-3">
                  <div>
                    <CircleCheck className="mt-1 h-5 w-5 text-[#004270]" />
                  </div>
                  <p className="text-slate-700 leading-7 p-0">
                    13% de descuento a funcionarios del Ministerio del Ambiente
                    y Energía.
                  </p>
                </div>
              </div>
            </div>

            {/* Becas */}
            <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-lg">
              <div className="mb-5 flex items-center gap-3">
                {/* Icono adaptado al Amarillo/Oro institucional */}
                <div className="rounded-xl bg-[#febe10]/10 p-3 text-[#febe10]">
                  <GraduationCap className="h-6 w-6" />
                </div>

                <h3 className="text-2xl font-bold text-slate-900">Becas</h3>
              </div>

              <div className="space-y-5">
                <div className="flex gap-3">
                  <CircleCheck className="mt-1 h-5 w-5 text-[#004270]" />
                  <div>
                    <p className="text-slate-700 leading-7 p-0">
                      10% adicional por Beca Convenio.
                    </p>
                    {/* Enlaces usando el azul institucional */}
                    <a
                      href="https://becas.utpl.edu.ec"
                      target="_blank"
                      className="mt-2 inline-flex items-center gap-2 font-semibold text-[#004270] transition hover:opacity-80"
                    >
                      Postula hoy mismo
                      <ChevronRight className="h-4 w-4" />
                    </a>
                  </div>
                </div>

                <div className="flex gap-3">
                  <CircleCheck className="mt-1 h-5 w-5 text-[#004270]" />
                  <div>
                    <p className="text-slate-700 leading-7 p-0">
                      Beca Discapacidad
                    </p>
                    <a
                      href="https://becas.utpl.edu.ec/"
                      target="_blank"
                      className="mt-2 inline-flex items-center gap-2 font-semibold text-[#004270] transition hover:opacity-80"
                    >
                      Consulta los requisitos
                      <ChevronRight className="h-4 w-4" />
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Pago */}
          <div className="mt-6 rounded-3xl bg-[#004270] p-8 text-white shadow-2xl">
            <div className="flex flex-col gap-6 lg:flex-row lg:items-center lg:justify-between">
              <div className="max-w-2xl">
                <div className="mb-4 inline-flex rounded-full bg-white/10 px-4 py-2 text-sm font-semibold text-slate-200">
                  Opciones de financiamiento
                </div>

                <div className="flex items-center gap-3">
                  {/* Detalle en Amarillo/Oro institucional */}
                  <CreditCard className="h-8 w-8 text-[#febe10]" />
                  <h3 className="text-3xl font-bold text-white m-0 p-0">
                    Difiere tu matrícula sin intereses
                  </h3>
                </div>

                <div className="mt-6 space-y-4">
                  <div className="flex items-center gap-3">
                    {/* Checkmarks internos usando Amarillo/Oro para resaltar sobre el fondo azul */}
                    <CircleCheck className="h-5 w-5 text-[#febe10]" />
                    <p className="text-slate-200 p-0 m-0">
                      Hasta <b>12 meses</b>.
                    </p>
                  </div>

                  <div className="flex items-center gap-3">
                    <CircleCheck className="h-5 w-5 text-[#febe10]" />
                    <p className="text-slate-200 p-0 m-0">
                      Hasta <b>24 meses</b> en montos mayores a $2.000.
                    </p>
                  </div>
                </div>
              </div>

              {/* Botón de acción principal usando el color #febe10 con texto oscuro o azul para excelente legibilidad */}
              <a
                href="https://utpl.edu.ec/documentos/opcionespago.pdf"
                target="_blank"
                className="inline-flex items-center justify-center gap-2 rounded-2xl bg-[#febe10] px-6 py-4 text-m font-bold text-[#004270] transition-all duration-300 hover:bg-[#febe10]/90 hover:shadow-lg"
              >
                Ver opciones de pago
                <ChevronRight className="h-5 w-5" />
              </a>
            </div>
          </div>

          {/* Accordion */}
          <div className="mt-8 rounded-2xl border border-slate-200 bg-white p-6 shadow-sm">
            <Accordion
              title="Plan de pagos (pagos semestrales)"
              content={
                <div className="space-y-4 text-slate-700">
                  {/* Alerta interna adaptada a un borde gris con sutil fondo gris e indicador de texto institucional */}
                  <p className="rounded-xl border border-slate-200 bg-slate-50 p-4 text-slate-800">
                    <b>
                      Si eliges un plan de pagos, no aplica el descuento por
                      forma de pago.
                    </b>
                  </p>

                  <div className="space-y-3">
                    <p className="flex gap-3 p-0 m-0">
                      <CircleCheck className="h-5 w-5 text-[#004270]" />
                      <span>
                        Paga 50% al matricularte y 50% a 60 días plazo.
                      </span>
                    </p>

                    <p className="flex gap-3 p-0 m-0">
                      <CircleCheck className="h-5 w-5 text-[#004270]" />
                      <span>
                        Paga 40% al matricularte, 30% hasta el 17 de noviembre y
                        30% hasta el 30 de diciembre de 2026.
                      </span>
                    </p>
                  </div>
                </div>
              }
            />
          </div>
        </div>
      </section>
    </>
  );
}

export function PosgradosPagosRecursos() {
  return (
    <>
      {
        <div className="icon350 descuentos-section" id="descuentos">
          <BlockLeftImage
            src="https://utpl.edu.ec/recursos/img/costos.gif"
            content={
              <>
                <h3>
                  Obtén hasta un <b>30% de descuento </b>en tu matrícula{" "}
                </h3>
                <p className="yellow">
                  <b>Descuentos:</b>
                </p>{" "}
                <p>
                  🟢 <b>10% de descuento</b> al pagar el programa completo o{" "}
                  <b>5% de descuento</b> si eliges pagar semestralmente. (El
                  pago semestral no aplica para programas de especialización).
                </p>
                <p>
                  🟢 <b>10% de descuento adicional </b>si eres UTPL Alumni.
                </p>
                <p>
                  🟢 <b>10% de descuento adicional </b> a funcionarios del
                  Ministerio de Ambiente y Energía, GAD provinciales o GAD
                  municipales. .
                </p>
                <p className="yellow">
                  <b>Becas:</b>
                </p>
                <p>
                  🟢 <b> 10% de descuento adicional</b> por Beca Convenio.
                </p>
                <a
                  className="link-with-arrow"
                  target="_blank"
                  href="https://becas.utpl.edu.ec/convenio"
                >
                  Postula hoy mismo
                </a>
                <p>🟢Beca Discapacidad</p>
                <a
                  className="link-with-arrow"
                  target="_blank"
                  href="https://becas.utpl.edu.ec/discapacidad"
                >
                  Consulta los requisitos
                </a>
                <h4>
                  <b>💳 ¡Difiere tu matrícula </b> <br></br> sin intereses!
                </h4>
                <p>
                  🟢Hasta <b>12 meses</b>
                </p>
                <p>
                  🟢Hasta <b>24 meses (aplica en montos mayores a $2 000)</b>
                </p>
                <a
                  className="link-with-arrow"
                  target="_blank"
                  href="https://utpl.edu.ec/documentos/opcionespago.pdf"
                >
                  Conoce aquí nuestras opciones de pago
                </a>
                <br></br> <br></br>
                <Accordion
                  title="Plan de pagos (pagos semestrales)"
                  content={
                    <>
                      <p>
                        <b>
                          Si optas por un plan de pagos, no obtendrás el
                          descuento por forma de pago.
                        </b>
                      </p>
                      <ul>
                        <li>
                          <p>
                            Paga 50% al momento de la matrícula y 50% a 60 días
                            plazo.
                          </p>
                        </li>

                        <li>
                          <p>
                            Paga 40% al momento de la matrícula, 30% hasta el 15
                            de mayo y 30% hasta el 1 de julio de 2026.
                          </p>
                        </li>
                      </ul>
                      <p></p>
                    </>
                  }
                ></Accordion>
              </>
            }
          ></BlockLeftImage>
        </div>
      }
    </>
  );
}

export function PagosEscuelaNegocios() {
  return (
    <>
      <DescuentosEscuelaNegocios></DescuentosEscuelaNegocios>
    </>
  );
}

function PosgradoPagos() {
  return (
    <>
      <DescuentosPosgrados></DescuentosPosgrados>
    </>
  );
}

export default PosgradoPagos;
